module.exports = __webpack_public_path__ + "img/img23.ff3478ba.png";